<button
  [class]="buttonClass"
  [disabled]="disabled()"
  (click)="handleClick($event)"
  class="flex items-center justify-center"
>
  <ng-container *ngIf="icon()">
    <ui-icon [icon]="icon() || iconTypes.Heart" [size]="size()" [fill]="iconFIll() || false" [color]="getIconColor()" class="mr-2"></ui-icon>
  </ng-container>
  <span *ngIf="text()">{{ text() }}</span>
</button>
